import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Slider from "react-slick";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

//UI Component
import MainBanner from "./MainBanner";
import VoucherComp from "../../components/Voucher";
import Icon from "../../components/Icon";
import Link from "../../components/Link";
import RestaurantCard from "../../components/RestaurantCard";

// Style
import HomeStyled from "./style";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Color from "../../assets/color";
import { SETTINGS } from "../../constant/settings";

const SampleNextArrow = (props) => {
  return props.onClick !== null ? (
    <div className="navigation-button next" onClick={props.onClick}>
      <Icon name="ios-arrow-dropright" color={Color.aluminium} />
    </div>
  ) : null;
};
const SamplePrevArrow = (props) => {
  return props.onClick !== null ? (
    <div className="navigation-button prev" onClick={props.onClick}>
      <Icon name="ios-arrow-dropleft" color={Color.aluminium} />
    </div>
  ) : null;
};

const slider_ourPartner = {
  infinite: false,
  dots: false,
  initialSlide: 0,
  speed: 2000,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesPerRow: 4,
  rows: 2,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  pauseOnFocus: true,
  lazyLoad: "progressive",
};

const slider_special_offer = {
  infinite: false,
  initialSlide: 0,
  speed: 500,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  pauseOnFocus: true,
  lazyLoad: "progressive",
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: "",
    };
  }

  componentDidMount() {
    this._loadAll();
  }

  componentDidUpdate(prevProps) {
    const { storeLocation } = this.props;
    if (prevProps.storeLocation !== storeLocation) {
      this._loadAll();
    }
  }

  _loadAll = () => {
    this._onLoadHomeOurPartner();
    this._onLoadHomeSpecialOffer();
    this._onLoadHomeRecommendedRes();
  };
  _onLoadHomeRecommendedRes = () => {
    const { storeLocation } = this.props;
    let params = {
      offset: 0,
      limit: 3,
      other: "[4]",
    };
    if (JSON.stringify(storeLocation) !== JSON.stringify({})) {
      params.state = storeLocation.data.state;
      if (storeLocation.data.state !== storeLocation.data.district) {
        params.district = storeLocation.data.district;
      }
    }
    this.props.onLoadHomeRecommededRes(params);
  };
  _onLoadHomeSpecialOffer = () => {
    const { storeLocation } = this.props;
    let params = {
      offset: 0,
      limit: 10,
    };
    if (JSON.stringify(storeLocation) !== JSON.stringify({})) {
      params.state = storeLocation.data.state;
      if (storeLocation.data.state !== storeLocation.data.district) {
        params.district = storeLocation.data.district;
      }
    }
    this.props.onLoadHomeSpecialOffer(params);
  };
  _onLoadHomeOurPartner = () => {
    this.props.onLoadHomeOurPartner({});
  };

  _goToRestaurantList = () => {
    this.props.history.push("/restaurant/list");
  };

  _goToLololMall = () => {
    this.props.history.push("/mall");
  };

  _showModalLocation = () => {
    this.props.onShowLocationModal();
    this.props.onGetListLocation();
  };

  _hideModalLocation = () => {
    this.props.onHideLocationModal();
  };

  // _submitLocation = param => {
  //   this.props.onSubmitLocation(param);
  // };

  _onClick = (d) => {
    window.open(`/voucher?id=${d.specialPackage_id}`, "_blank");
  };

  _countLength = (d) => {
    if (d !== 0) {
      return d;
    }
  };

  _goToShopList = (name = "", value) => {
    let params = {};
    params[name] = value;

    this.props.history.push({
      pathname: "/restaurant/list",
      state: params,
    });
  };

  render() {
    const {
      storeLocation,
      homeOurPartner,
      homeSpecialOffer,
      homeRecommendedRes,
    } = this.props;

    const services_btn = [
      {
        name: "DELIVERY",
        image: require("../../assets/img/home_delivery.png"),
        onClick: () => {
          if (!SETTINGS.closed) {
            this.props.history.push("delivery/select-address");
          }
        },
        closed: SETTINGS.closed,
      },
      //   {
      //     name: "RESERVATION",
      //     image: require("../../assets/img/home_reservation.png"),
      //     coming_soon: true,
      //     onClick: () => {},
      //     // onClick: () =>
      //     //   this.props.history.push({
      //     //     pathname: "/restaurant/list",
      //     //     state: "reservation"
      //     //   })
      //   },
      {
        name: "PICK UP",
        image: require("../../assets/img/home_pick_up.png"),
        onClick: () => {
          if (!SETTINGS.closed) {
            this.props.history.push({
              pathname: "/restaurant/list",
              state: "pick_up",
            });
          }
        },
        closed: SETTINGS.closed,
      },
    ];

    return (
      <HomeStyled>
        <div className="App">
          <MainBanner />
          <section className="select-location bg-primary">
            <div className="container">
              <div
                className="location d-flex align-items-center"
                onClick={() => this._showModalLocation()}
              >
                <div className="mr-2">
                  <Icon
                    type="simple-line-icons"
                    color={Color.white}
                    size={20}
                    name="location-pin"
                  />
                </div>
                <p className="location mb-0">
                  {JSON.stringify(storeLocation.data) !== JSON.stringify({})
                    ? storeLocation.data.state +
                      " > " +
                      storeLocation.data.district
                    : "Select Location"}
                </p>
                <div className="ml-3">
                  <Icon
                    type="font-awesome"
                    color={Color.white}
                    size={16}
                    name="pencil"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Our Services */}
          <section className="our-services p-section">
            <div className="container">
              <h1 className="home-title">Our Services</h1>
              <Row>
                {services_btn.map((d, i) => {
                  return (
                    <Col md={4} xs={4} key={i}>
                      <div className="contain" onClick={d.onClick}>
                        <div className="position-relative bg-athensGrey box d-flex justify-content-center align-items-center mb-3">
                          {d.closed !== undefined && (
                            <div className="coming-soon">
                              <p className="text">
                                Temporary CLOSED from 8/12/2022 <br />
                                until further notice
                              </p>
                            </div>
                          )}
                          {d.coming_soon !== undefined && (
                            <div className="coming-soon">
                              <p className="text">Coming Soon</p>
                            </div>
                          )}
                          <div className="image-wrapper">
                            <img alt={d.name} src={d.image} />
                          </div>
                        </div>
                        <div className="name mb-3">
                          <p>{d.name}</p>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </section>
          {/* END Our Services */}
          {/* Restaurant - Mall */}
          <section className="container-restaurant-mall-button p-section">
            <Container>
              <Row className="buttons-container">
                <Col sm={6} xs={12}>
                  <div
                    className="inner-container"
                    onClick={this._goToRestaurantList}
                  >
                    <img
                      className="icon"
                      src={require("../../assets/img/icon-restaurant.png")}
                      alt=""
                    />
                    <h3>Restaurant</h3>
                    <p>
                      Getting the food you love from your favourite restaurant.
                    </p>
                  </div>
                </Col>
                <Col sm={6} xs={12}>
                  <div
                    className="inner-container"
                    onClick={this._goToLololMall}
                  >
                    <img
                      className="icon"
                      src={require("../../assets/img/icon-lolol-mall.png")}
                      alt=""
                    />
                    <h3>LOLOL Mall</h3>
                    <p>Shop online and discover LOLOL Mall.</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>{" "}
          {/* END Restaurant - Mall */}
          {/* Our Partner */}
          <section className="our-partner p-section">
            <h1 className="home-title">Our Partner</h1>
            <div className="container">
              <Slider {...slider_ourPartner}>
                {homeOurPartner.data.map((d, i) => {
                  return (
                    <div
                      key={i}
                      className="contain"
                      onClick={() =>
                        this._goToShopList(
                          "business_category",
                          d.category_group
                        )
                      }
                    >
                      <div className="square-box">
                        <div className="item d-inline-block text-center mb-2">
                          <img src={d.path} alt="" />
                        </div>
                        <div className="label">
                          <p>{d.category_group}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </section>
          {/* END Our Partner */}
          {/* Special Offer */}
          <section className="special-offer bg-athensGrey p-section">
            <h1 className="home-title">Special Offer</h1>
            <div className="container">
              <Row>
                <Col>
                  {JSON.stringify(homeSpecialOffer) !== JSON.stringify({}) && (
                    <div>
                      <Slider {...slider_special_offer}>
                        {homeSpecialOffer.data.map((d, i) => {
                          return (
                            <div key={i} className="voucher-comp">
                              <VoucherComp
                                type={d.package_type}
                                data={d}
                                onClick={() => this._onClick(d)}
                              />
                            </div>
                          );
                        })}
                      </Slider>
                      <a href="/voucher/list" className="see-more mt-2">
                        See More{" "}
                        {this._countLength(
                          homeSpecialOffer.total - homeSpecialOffer.data.length
                        )}{" "}
                        <Icon
                          type="font-awesome"
                          name="caret-right"
                          color={Color.primary}
                          size={20}
                        />
                      </a>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </section>
          {/* END Special Offer */}
          {/* Recommended Restaurant */}
          <section className="recommeded-restaurant p-section">
            <h1 className="home-title">Recommended Shop</h1>
            <div className="container">
              <Row>
                {JSON.stringify(homeRecommendedRes) !== JSON.stringify({}) && (
                  <React.Fragment>
                    {homeRecommendedRes.data.map((d, i) => {
                      return (
                        <Col xl={4} key={i} className="mb-3">
                          <RestaurantCard key={i} type="card-info" data={d} />
                        </Col>
                      );
                    })}
                    <Col lg={12}>
                      <Link
                        to="/restaurant/list"
                        className="see-more mt-2"
                        onClick={(e) => {
                          e.preventDefault();
                          this._goToShopList("recommended", true);
                        }}
                      >
                        See More{" "}
                        {this._countLength(
                          homeRecommendedRes.total -
                            homeRecommendedRes.data.length
                        )}{" "}
                        <Icon
                          type="font-awesome"
                          name="caret-right"
                          color={Color.primary}
                          size={20}
                        />
                      </Link>
                    </Col>
                  </React.Fragment>
                )}
              </Row>
            </div>
          </section>
          {/* END Recommended Restaurant */}
        </div>
      </HomeStyled>
    );
  }
}

Home.propTypes = {
  locationModalVisible: PropTypes.bool.isRequired,
  homeOurPartner: PropTypes.object.isRequired,
  homeSpecialOffer: PropTypes.object.isRequired,
  homeRecommendedRes: PropTypes.object.isRequired,
  storeLocation: PropTypes.object.isRequired,
  isFirstLoad: PropTypes.bool.isRequired,
  // Function
  onGetListLocation: PropTypes.func.isRequired,
  onSubmitLocation: PropTypes.func.isRequired,
  onLoadHomeOurPartner: PropTypes.func.isRequired,
  onLoadHomeSpecialOffer: PropTypes.func.isRequired,
  onLoadHomeRecommededRes: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    // isLoadingLocationList: state.App.isLoading,
    isFirstLoad: state.App.isFirstLoad,
    getListLocation: state.Location.locationlist,
    getLocationData: state.Location.submitLocation,
    locationModalVisible: state.Location.locationModalVisible,
    storeLocation: state.Location.storeLocation,
    homeOurPartner: state.Mall.homeOurPartner,
    homeSpecialOffer: state.Voucher.homeSpecialOffer,
    homeRecommendedRes: state.Restaurant.homeRecommendedRes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetListLocation: () => dispatch(actions.getLocationList()),
    onSubmitLocation: (params) => dispatch(actions.submitLocation(params)),
    onShowLocationModal: () => dispatch(actions.showModalLocation()),
    onHideLocationModal: () => dispatch(actions.hideModalLocation()),
    onLoadHomeOurPartner: (params) =>
      dispatch(actions.homeLoadOurPartner(params)),
    onLoadHomeSpecialOffer: (params) =>
      dispatch(actions.onLoadHomeSpecialOffer(params)),
    onLoadHomeRecommededRes: (params) =>
      dispatch(actions.loadHomeRecommededRes(params)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
